import DefaultConfirmDialog from "./DefaultConfirmDialog";
import NetworkingFlowDialog from "joynt/modals/confirm/NetworkingFlowDialog";
import { confirmTypes } from "joynt/edit/types";

export default {
    ...confirmTypes,
    networking: NetworkingFlowDialog,
    default: DefaultConfirmDialog,
};
